import { Component } from '@angular/core';
import { ComputeServiceVc } from './compute-vc.service';
import { TranslateService } from '@ngx-translate/core';
import { GlobalVariables } from '../../../../../common/global-variables';
import { VcaAlertsService } from '../../../../../common/vca-alerts/vca-alerts.service';
import { Subscription } from 'rxjs/Rx';
import { RefreshSharedService } from '../../../../refresh-shared-service';

@Component({
    selector: 'dashboard-compute-vc',
    styles: [require('./compute-dashboard-vc.scss')],
    templateUrl: './compute-dashboard-vc.component.html'
})

export class ComputeDashboardVc {

    private tableData: any = [];
    private isTranslationready: boolean = true;
    private isLoading: boolean = true;
    private rsService: RefreshSharedService;
    private refreshSubscription: Subscription;
    private currentClassName: string = '';

    constructor(private service: ComputeServiceVc,
                private translate: TranslateService,
                private alert: VcaAlertsService,
                private rss: RefreshSharedService) {
        translate.use(GlobalVariables.LOCALE);
        this.rsService = rss;
        this.currentClassName = 'ComputeDashboardVc';
    }

    ngOnInit() {
        this.refreshSubscription = this.rsService.getRefreshParam()
        .subscribe (
        item => {
          this.handleEmittedValues(item);
        });

        this.rsService.setParam({
            'loadedComponent': this.currentClassName,
            'detailPageIDName': '',
            'shouldReloadInventoryTree': false
        });
        this.getAllVCs();
    }

    handleEmittedValues(item) {
        if (item.loadedComponent === this.currentClassName) {
            this.getAllVCs();
        }
    }

    getAllVCs() {
        this.tableData = [];
        this.isLoading = true;
        this.service.getVcList()
            .subscribe(
                data => {
                    this.tableData = data;
                    this.isLoading = false;
                },
                error => {
                    this.alert.danger(['Failed to retrieve VCenters', error], 'vcenter-grid');
                    this.isLoading = false;
                }
            );
    }

    ngOnDestroy() {
        this.rsService.resetParam();
        if (this.refreshSubscription) {
            this.refreshSubscription.unsubscribe();
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/components/compute/compute-vc/dashboard-vc/compute-dashboard-vc.component.ts